import React from 'react';
import { Caption } from '~/shared/Typography';
import { VStack, Box, Pressable, IPressableProps } from 'native-base';
import { useTheme } from '@springbig/shared';

export type VariantCardProps = IPressableProps & {
    id: string;
    name: string;
    price: number;
    specialPrice: number | null;
    isSelected: boolean;
    onPress: (id: string) => void;
};

export const VariantCard = ({
    id,
    name,
    price,
    specialPrice,
    isSelected,
    onPress,
    ...props
}: VariantCardProps) => {

    const {
        button_primary,
        button_text,
        radius_md,
        radius_sm,
    } = useTheme();

    const percentageCalculator = (): string => {

        return Math.round(((price - specialPrice) / price) * 100) + '% off';
    };

    return (
        <Pressable
            onPress={() => onPress(id)}
            {...props}
        >
            <VStack
                borderColor={button_primary}
                bg={isSelected ? button_primary : button_text}
                borderWidth={1}
                rounded={radius_md}
                px={4} py={2}
                alignItems={'center'}
                justifyContent={'space-evenly'}
                zIndex={1}
                flex={1}
            >
                <Caption color={isSelected ? button_text : button_primary}>
                    { name === 'N/A' ? '' : name }
                </Caption>
                <>
                    <Caption
                        color={isSelected ? button_text : button_primary}
                        opacity={specialPrice ? .4 : 1}
                        style={specialPrice ? { textDecorationLine: 'line-through' } : {}}
                    >
                        ${ price }
                    </Caption>
                    <Caption color={isSelected ? button_text : button_primary}>
                        { specialPrice ? `$${specialPrice}` : '' }
                    </Caption>
                </>
            </VStack>
            { specialPrice &&
                <Box position={'relative'}>
                    <Box
                        position={'absolute'}
                        borderColor={button_primary}
                        bg={isSelected ? button_text : button_primary}
                        borderWidth={1}
                        borderTopWidth={0}
                        roundedBottom={radius_sm}
                        w={'100%'}
                        bottom={0}
                        top={-24}
                        zIndex={-1}
                    ></Box>
                    <Caption
                        textAlign={'center'}
                        p={1}
                        fontSize={12}
                        color={isSelected ? button_primary : button_text}
                    >
                        { percentageCalculator() }
                    </Caption>
                </Box>
            }
        </Pressable>
    );
};
